export const CAMPANHAS_LOADING = 'CAMPANHAS_LOADING';
export const CAMPANHAS_DATA = 'CAMPANHAS_DATA';